import React, { useState, useEffect, useMemo } from "react";

const LocaleSwitcher = ({ location }) => {
    const [ localeOpen, setLocaleOpen ] = useState(false);
    const [usUrl, setUsUrl] = useState(null);
    const [ukUrl, setUkUrl] = useState(null);

    const isUs = useMemo(() => {
        if(process.env.GATSBY_locale === "en-US") {
            return true;
        }
        return false;
    }, []);

    useEffect(() => {
        if (typeof location !== "undefined") {
            if (isUs) {
                let usUrl = "https://flauntdigital.com" + location.pathname;
                setUsUrl(usUrl.split("//").join("//us."));
                setUkUrl(usUrl);
            } else {
                let ukUrl = "https://us.flauntdigital.com" + location.pathname;
                setUsUrl(ukUrl);
                setUkUrl(ukUrl.replace("us.", ""));
            }
        }
    }, [location]);

    return (
        <div className="locale-switcher-wrapper">
            <div className="locale-switcher-desktop-links">
                <a
                    className={`locale-link ${!isUs && "active"}`}
                    href={ukUrl}
                >UK</a>
                |
                <a
                    className={`locale-link ${isUs && "active"}`}
                    href={usUrl}
                >US</a>
            </div>
            <div className="locale-switcher-mobile-links">
                <span
                    className={`locale-switcher locale-switcher-${localeOpen?'open':'close'}`}
                    onClick={e=>{
                        if(e.target.classList.contains("locale-switcher")) {
                            setLocaleOpen(!localeOpen);
                        }else if(e.target.classList.contains("active")) {
                            setLocaleOpen(!localeOpen);
                        }
                    }}
                >
                    <ul
                        className={`locale-link-list ${isUs&&"reverse"}`}
                    >
                        <li
                            className={`locale-link-list-item ${!isUs && "active"}`}
                        >
                            <a
                                className={`locale-link ${!isUs && "active"}`}
                                href={ localeOpen ? ukUrl : ""}
                            >UK</a>
                        </li>
                        <li
                            className={`locale-link-list-item ${isUs && "active"}`}
                        >
                            <a
                                className={`locale-link ${isUs && "active"}`}
                                href={usUrl}
                            >US</a>
                        </li>
                    </ul>
                </span>
            </div>
        </div>
    )
}

export default LocaleSwitcher;